/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {x: 0, y: 0}
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/Home.vue'),
        },
        {
          path: '/reservations/:type/:id',
          name: 'reservations',
          component: () => import('./views/Reservations.vue')
        },
        {
          path: '/reservations/pending',
          name: 'pendingReservation',
          component: () => import('./views/PendingReservations.vue')
        },
        /*{
          path: '/reservations/approved',
          name: 'approvedReservations',
          component: () => import('./views/ApprovedReservations.vue')
        },*/
        {
          path: '/events',
          name: 'events',
          component: () => import('./views/Events.vue')
        },
        {
          path: '/locations',
          name: 'locations',
          component: () => import('./views/Locations.vue')
        },
        {
          path: '/contents',
          name: 'contents',
          component: () => import('./views/Contents.vue')
        },
        {
          path: '/gallery',
          name: 'gallery',
          component: () => import('./views/Gallery.vue')
        },
        {
          path: '/customers',
          name: 'customers',
          component: () => import('./views/Customers.vue')
        },
        {
          path: '/admins',
          name: 'admins',
          component: () => import('./views/Admins.vue')
        },
        {
          path: '/agb',
          name: 'agb',
          component: () => import('./views/Agb.vue')
        },
        {
          path: '/impressum',
          name: 'impressum',
          component: () => import('./views/Impressum.vue')
        },
        {
          path: '/datenschutz',
          name: 'datenschutz',
          component: () => import('./views/Datenschutz.vue')
        },

        {
          path: '/payment',
          name: 'payment',
          component: () => import('./views/Payment.vue')
        },
        {
          path: '/payments',
          name: 'payments',
          component: () => import('./views/Payments.vue')
        },
        /*{
          path: '/profile',
          name: 'profile',
          component: () => import('./views/Profile.vue')
        },*/
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue'),
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.beforeEach((to, from, next) => {
  // ...
  if (localStorage.getItem('token') === null && localStorage.getItem('user') === null  && to.path !== '/pages/login') {
    next('/pages/login'); // allow to enter route
  } else {
    next(); // go to app;
  }
})


router.afterEach((to, from, next) => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }

})

export default router
